import { render, staticRenderFns } from "./PhoneInputComponent.vue?vue&type=template&id=db4184ba&scoped=true&lang=pug"
import script from "./PhoneInputComponent.vue?vue&type=script&lang=ts"
export * from "./PhoneInputComponent.vue?vue&type=script&lang=ts"
import style0 from "./PhoneInputComponent.vue?vue&type=style&index=0&id=db4184ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4184ba",
  null
  
)

export default component.exports